import { Component } from "../../types";

export function initAllComponents(component: Component) {
  if (component && 'init' in component && typeof component.init === 'function') {
    component.init();
  }

  if (component.children) {
    for (const child in component.children) {
      if (Object.prototype.hasOwnProperty.call(component.children, child)) {
        const childComp = component.children[child];
        initAllComponents(childComp);
      }
    }
  }

}

export function cleanUpAllChildren(component: Component) {
  if (component && 'cleanUp' in component && typeof component.cleanUp === 'function') {
    component.cleanUp();
  }

  for (const child in component.children) {
    if (Object.prototype.hasOwnProperty.call(component.children, child)) {
      const childComp = component.children[child];
      cleanUpAllChildren(childComp);
    }
  }
}